module.exports = __webpack_public_path__ + "static/media/Mopex E.dba53f8e.jpeg";